import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { getQuarterHourPeriodizer } from '../../data/aws/s3/AccumulationPeriodization';
import { getZombieInstanceFromPrimaryKey, Milliseconds } from '@iotv/datamodel-core';
const debug = process.env.REACT_APP_DEBUG && false;
export const ObjectDataPeriodizationCard = ({ viewObject }) => {
    const [periodizer, setPeriodizer] = React.useState(undefined);
    useEffect(() => {
        const vob = getZombieInstanceFromPrimaryKey(viewObject.matchedPrimary?.sk ?? 'never');
        debug && console.log('getQuarterHourPeriodizer', vob);
        getQuarterHourPeriodizer(vob).then(({ err, data }) => {
            setPeriodizer(data ?? undefined);
            debug && console.log('periodizer', data);
        });
    }, []);
    return periodizer ? _jsx("div", { children: JSON.stringify(periodizer.toSnapShotByTimestampRange([Date.now() - Milliseconds.DAY, Date.now()])) }) : _jsx("div", { children: "Waiting" });
};
